<div class="pages-container">
    <nt-page *ngFor="let productPage of productPages"
             [productPage]="productPage"
             class="pt-page"
             [@currentTab]="productPage.pageSelected ? 'open' : 'closed'"
             (@currentTab.start)="transitionStart(productPage)"
             (@currentTab.done)="transitionEnd(productPage)">
    </nt-page>
</div>
